export default {
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  border: true,
  hover: 'light-7',
  padding: '2',
  fontSize: '3',
  fareBodyItem: {
    grow: '1',
    textColor: 'dark',
    justifyContent: 'between',
  },
  fareFooterItem: {
    flexDirection: 'row',
    justifyContent: 'end',
    alignItems: 'center',
    textColor: 'dark',
    grow: '1',
  },
  showOriginDestinationImage: false,
  showRoute: false,
  showJourneyType: false,
  showTravelClass: false,
  showReturnInfo: false,
  showDepartureInfo: true,
  showCallToAction: true,
  showPrice: true,
  fareItemOriginDestination: {
    showOriginAirportCode: false,
    showDestinationAirportCode: false,
    showSeparator: false,
    showOrigin: false,
    fontWeight: 'bold',
    fontSize: '4',
    textTransform: 'uppercase',
    style: { lineHeight: '1' },
  },
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
  },
  fareItemReturnInfo: {},
  fareItemJourneyType: {},
  fareItemTravelClass: {},
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    fontWeight: 'bold',
    textAlign: 'right',
    paddingWidth: '3',
    pricePromoStyles: {
      fontWeight: 'bold',
    },
    currencyStyles: {
      fontSize: '4',
    },
  },
  fareItemCallToAction: {
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
    showCallToActionTextMin: true,
    style: { paddingLeft: '2em', paddingRight: '2em' },
  },
};
